import React from 'react';
import { withWrapper } from '@shared/react';
import {
    TransactionsTableProvider,
    useTransactionsTable,
    getTransactionsTableColumns,
    getTransactionsTableRows,
    TRANSACTIONS_TABLE_TITLE,
    TRANSACTIONS_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import { TransactionsTableFilters } from './components';
import './TransactionsTable.scss';

const TransactionsTableContent: React.FC<{ orderId: number }> = ({ orderId }) => {
    const { transactions, transactionsLoading, paginationOptions, onTransactionViewClick } = useTransactionsTable();

    const userStorage = localStorage.getItem('User');
    let userObject: any = null;
    userObject = JSON.parse(userStorage ? userStorage : '');

    return (
        <Table
            columns={getTransactionsTableColumns()}
            data={transactions}
            dataLoading={transactionsLoading}
            tableTitle={orderId ? undefined : TRANSACTIONS_TABLE_TITLE}
            infoLink={TRANSACTIONS_TABLE_INFO_URL}
            filters={orderId ? undefined : <TransactionsTableFilters />}
            paginationOptions={paginationOptions}
            row={userObject ? undefined : getTransactionsTableRows({ onTransactionViewClick })}
        />
    );
};

export const TransactionsTable = withWrapper(TransactionsTableProvider)(TransactionsTableContent);
